import { render, staticRenderFns } from "./editorStaff.vue?vue&type=template&id=44ecc7ee"
import script from "./editorStaff.vue?vue&type=script&lang=js"
export * from "./editorStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports